import { makeRequest } from "src/api/request";

export const getMonitorsCategories = async () =>
  await makeRequest.get<API.LocalPulse.monitorCategoryList.Response>("/local-pulse/monitor-categories/");

export const getMonitorsNews = async (params: API.LocalPulse.NewsMonitors.Request) =>
  await makeRequest.get<API.LocalPulse.NewsMonitors.Response>("/local-pulse/local-monitor/", {
    params,
  });
